module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/components/Squad/images/border-top.285bd122.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/components/Squad/images/border-top.png
// module id = 2741
// module chunks = 11